import { create } from 'zustand';
import * as api from '../api';

interface AuthState {
  user: { id: number; username: string } | null;
  checked: boolean;
  checkAuth: () => Promise<void>;
  login: (username: string, password: string) => Promise<void>;
  register: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  checked: false,
  checkAuth: async () => {
    try {
      const { user } = await api.checkAuth();
      set({ user, checked: true });
    } catch {
      set({ user: null, checked: true });
    }
  },
  login: async (username, password) => {
    const { user } = await api.login(username, password);
    set({ user });
  },
  register: async (username, password) => {
    const { user } = await api.register(username, password);
    set({ user });
  },
  logout: async () => {
    await api.logout();
    set({ user: null });
  },
}));
